var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49935 2.08268C9.49935 1.77326 9.37643 1.47652 9.15764 1.25772C8.93885 1.03893 8.6421 0.916016 8.33268 0.916016H1.33268C1.02326 0.916016 0.726517 1.03893 0.507724 1.25772C0.288932 1.47652 0.166016 1.77326 0.166016 2.08268V7.91602C0.166016 8.22544 0.288932 8.52218 0.507724 8.74097C0.726517 8.95977 1.02326 9.08268 1.33268 9.08268H8.33268C8.6421 9.08268 8.93885 8.95977 9.15764 8.74097C9.37643 8.52218 9.49935 8.22544 9.49935 7.91602V5.97177L11.8327 7.91602V2.08268L9.49935 4.02693V2.08268ZM7.16602 5.58268H5.41602V7.33268H4.24935V5.58268H2.49935V4.41602H4.24935V2.66602H5.41602V4.41602H7.16602V5.58268Z",
    fill: "#F28181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.59a2e6f345891d7780fcf8035620bf7e.svg";
export { ForwardRef as ReactComponent };